(() => {
  const theme = window.theme || { routes: {}, strings: {} };
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  let toastTimer;
  const showToast = (message, isError) => {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('[data-toast-msg]').textContent = message;
    toast.querySelector('.toast__link').hidden = !!isError;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };

  const updateCartCount = async () => {
    try {
      const res = await fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cart.currency || 'GBP' }).format(cart.total_price / 100);
      $$('[data-cart-total]').forEach((el) => { el.textContent = total; });
    } catch (e) { /* count refreshes on next page load */ }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cart-add')) return;
    if (!window.fetch || !theme.routes.cart_add_url) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = theme.strings.adding; }
    try {
      const res = await fetch(`${theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || theme.strings.error);
      showToast(theme.strings.added.replace('{{ title }}', data.product_title || data.title || ''));
      await updateCartCount();
    } catch (err) {
      showToast(err.message || theme.strings.error, true);
    } finally {
      if (button) { button.disabled = false; button.textContent = label; }
    }
  });

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  $$('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.form;
      clearTimeout(input._t);
      input._t = setTimeout(() => form && form.querySelector('[data-cart-update]') && form.querySelector('[data-cart-update]').click(), 600);
    });
  });

  $$('[data-auto-submit]').forEach((el) => el.addEventListener('change', () => el.form && el.form.submit()));
  $$('[data-filter-form] input[type="checkbox"]').forEach((el) => el.addEventListener('change', () => el.form.submit()));

  document.addEventListener('click', (event) => {
    $$('details.drop[open], details.hdr-search[open], details.burger[open]').forEach((d) => {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    $$('details.drop[open], details.hdr-search[open], details.burger[open]').forEach((d) => {
      d.removeAttribute('open');
      const summary = d.querySelector('summary');
      if (summary) summary.focus();
    });
  });
  $$('details.hdr-search').forEach((d) => d.addEventListener('toggle', () => {
    if (d.open) { const input = d.querySelector('input[type="search"]'); if (input) input.focus(); }
  }));

  $$('.notify').forEach((d) => {
    if (d.querySelector('.form-msg')) {
      d.open = true;
      d.scrollIntoView({ block: 'center' });
    }
  });

  $$('[data-product-grid]').forEach((grid) => {
    const chips = $$('.chip[data-filter]', grid);
    const cards = $$('.card', grid);
    const empty = grid.querySelector('[data-grid-empty]');
    chips.forEach((chip) => chip.addEventListener('click', () => {
      chips.forEach((c) => { c.classList.toggle('on', c === chip); c.setAttribute('aria-pressed', c === chip); });
      const f = chip.dataset.filter;
      let visible = 0;
      cards.forEach((card) => {
        let show = true;
        const extra = card.hasAttribute('data-extra');
        if (f === 'instock') show = !extra && card.dataset.available === 'true';
        else if (f === 'all') show = !extra;
        else show = (card.dataset.filters || '').split(' ').includes(f);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (empty) {
        empty.hidden = visible > 0;
        if (!visible) {
          empty.querySelector('[data-grid-empty-text]').textContent = theme.strings.empty_filter;
          const link = empty.querySelector('[data-grid-empty-link]');
          if (chip.dataset.url) { link.href = chip.dataset.url; link.textContent = `${chip.dataset.label} →`; }
        }
      }
    }));
  });

  $$('[data-product-section]').forEach((section) => {
    const mainImg = section.querySelector('.pdp__main img');
    const setImage = (src, srcset) => {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
    };
    $$('[data-thumb]', section).forEach((thumb) => thumb.addEventListener('click', () => {
      $$('[data-thumb]', section).forEach((t) => t.classList.toggle('on', t === thumb));
      setImage(thumb.dataset.src, thumb.dataset.srcset);
    }));

    const select = section.querySelector('[data-variant-select]');
    const variantsEl = section.querySelector('[data-variants]');
    const stringsEl = section.querySelector('[data-product-strings]');
    if (!select || !variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);
    const strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    const priceEl = section.querySelector('[data-price]');
    const badges = section.querySelector('[data-badges]');
    const button = section.querySelector('[data-add-button]');
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      if (priceEl) {
        priceEl.innerHTML = v.compare
          ? `<span class="visually-hidden">${esc(strings.sale_price)}</span><span class="now red">${esc(v.price)}</span><span class="visually-hidden">${esc(strings.regular_price)}</span><s>${esc(v.compare)}</s>`
          : `<span class="now">${esc(v.price)}</span>`;
      }
      if (badges) {
        let html = v.available ? `<span class="badge in">${esc(theme.strings.in_stock)}</span>` : `<span class="badge out">${esc(theme.strings.sold_out)}</span>`;
        if (v.saving) html += `<span class="badge sale">${esc(strings.save.replace('__AMOUNT__', v.saving))}</span>`;
        badges.innerHTML = html;
      }
      if (button) {
        button.disabled = !v.available;
        button.textContent = v.available ? theme.strings.add : theme.strings.sold_out;
      }
      if (v.image) setImage(v.image, '');
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  $$('[data-recommendations]').forEach(async (el) => {
    if (!el.dataset.url || el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* recommendations are optional */ }
  });

  // Collection sidebar starts collapsed on small screens
  if (window.matchMedia('(max-width: 900px)').matches) {
    $$('[data-plp-side]').forEach((d) => d.removeAttribute('open'));
  }

  // Hero carousel: fade slides, dots, arrows, autoplay (paused on hover/focus and for reduced motion)
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-carousel]').forEach((root) => {
    const slides = $$('[data-carousel-slide]', root);
    const dots = $$('[data-carousel-dot]', root);
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        $$('a', slide).forEach((a) => { if (active) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    const seconds = Number(root.dataset.autoplay || 0);
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (seconds > 0 && !reduceMotion) timer = setInterval(() => go(index + 1), seconds * 1000);
    };
    dots.forEach((dot) => dot.addEventListener('click', () => { go(Number(dot.dataset.carouselDot)); start(); }));
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', () => { go(index - 1); start(); });
    if (next) next.addEventListener('click', () => { go(index + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    let touchX = null;
    root.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      touchX = null;
    });
    start();
  });

  // Product rows: arrow buttons scroll one "page" of cards
  $$('[data-row]').forEach((row) => {
    const track = row.querySelector('[data-row-track]');
    const prev = row.querySelector('[data-row-prev]');
    const next = row.querySelector('[data-row-next]');
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    const page = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (prev) prev.addEventListener('click', () => page(-1));
    if (next) next.addEventListener('click', () => page(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
